// extracted by mini-css-extract-plugin
export var sliderNavigation = "slider-navigation-module--slider-navigation--jxvAH";
export var sliderNavigation__button = "slider-navigation-module--slider-navigation__button---Rr8S";